import Rest from '../Rest'

/**
 * Cadastro guiado do profissional autônomo.
 *
 * O restante da gestão (grid, edição, endereço, telefone, banco, modalidades,
 * imagens, KYC) passa por LegalEntityService: o profissional é uma linha de
 * corp.legal_entities com person_type = 'NE'. Só o cadastro inicial tem recurso
 * próprio, porque cria usuário, pessoa, fornecedor e vínculos de uma vez.
 */
export default class ProfessionalService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/professionals'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  register(payload: any) {
    return this.post('/register', payload).then(data => {
      return data
    })
  }
}
